module.exports = __webpack_public_path__ + "img/avatar1.b2f4957a.png";